"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-five/sections/journeySection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type JourneySectionJourneyFivesItem = {
    key: Key | null | undefined;
    /** Detected variants: "journey-item-five" | "journey-item-five mb-0" */
    className: string;
    /** Detected variants: "01" | "02" | "03" */
    div0Text: ReactNode;
    /** Detected variants: "Choose Your Service & Specialist" | "Select Date & Time" | "Pick Your Doctor & Service" */
    h30Text: ReactNode;
    /** Detected variants: "Select the ENT concern (ear, nose, throat) and pick the right doctor based on expertise." | "Choose a convenient date and time from the doctor’s available schedule to book your appointment without any hassle." */
    p0Text: ReactNode;
    /** Detected variants: "count" */
    div0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
};
export type HomeFiveJourneySectionGeneratedProps = {
    divDiv1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: JourneySectionJourneyFivesItem) => Partial<ComponentProps<"h3">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "OUR PROCESS" */
    sectionDiv0Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "icon" */
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/title-icon1.svg" */
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Our Appointment Journey" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Booking an ENT consultation is easy and transparent. Patients can explore services, select an experienced ENT specialist, schedule a suitable date and time, and complete the appointment in minutes." */
    sectionDiv0Div0Div1Div0Div0P0PText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "journey-img" */
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/journey-img.jpg" */
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    journeySectionJourneyFives: JourneySectionJourneyFivesItem[];
    journeySectionJourneyFivesItemWrapper?: (item: JourneySectionJourneyFivesItem, content: ReactNode) => ReactNode;
    journeySectionJourneyFivesRenderer?: (defaultNode: ReactNode) => ReactNode;
    journeySectionJourneyFivesH3Visible?: boolean;
    journeySectionJourneyFivesH3Renderer?: (item: JourneySectionJourneyFivesItem, defaultNode: ReactNode) => ReactNode;
    journeySectionJourneyFivesH3Props?: Partial<ComponentProps<"h3">> | ((item: JourneySectionJourneyFivesItem) => Partial<ComponentProps<"h3">>);
};

const HomeFiveJourneySectionGenerated: FC<HomeFiveJourneySectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0DivText = "OUR PROCESS",
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/title-icon1.svg",
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0H20H2Text = "Our Appointment Journey",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div1Div0Div0P0PText = "Booking an ENT consultation is easy and transparent. Patients can explore services, select an experienced ENT specialist, schedule a suitable date and time, and complete the appointment in minutes.",
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageAlt = "journey-img",
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/journey-img.jpg",
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageProps,
    divDiv1H30H3Props,
    sectionDiv0Div0ClassName,
    sectionDiv0Div1ClassName,
    journeySectionJourneyFives,
    journeySectionJourneyFivesItemWrapper,
    journeySectionJourneyFivesRenderer,
    journeySectionJourneyFivesH3Visible,
    journeySectionJourneyFivesH3Renderer,
    journeySectionJourneyFivesH3Props,
}) => {
    return (
        <section className="journey-section-five section">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row align-items-center"}>
                    <div className="col-lg-6">
                        <div className="section-header section-header-five">
                            <div className="section-sub-title">
                                {" "}
                                {renderNode(sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                                {sectionDiv0Div0Div0Div0Div0DivText}
                            </div>
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 className="section-title" {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>{sectionDiv0Div0Div0Div0H20H2Text}</h2>
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="journey-right">
                            <div className="section-header section-header-five">
                                <p className="mt-0">{sectionDiv0Div0Div1Div0Div0P0PText}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row"}>
                    <div className="col-lg-6">
                        <div className="journey-img">
                            {renderNode(sectionDiv0Div1Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div0Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div1Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div1Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        {renderCollectionNode(
                            journeySectionJourneyFives,
                            (item: JourneySectionJourneyFivesItem) => (
                                <div className={item.className} key={item.key}>
                                    <div className={item.div0ClassName ?? "count"}>{item.div0Text}</div>
                                    <div>
                                        {renderItemNode(journeySectionJourneyFivesH3Visible, journeySectionJourneyFivesH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof journeySectionJourneyFivesH3Props === "function" ? journeySectionJourneyFivesH3Props(item) : (journeySectionJourneyFivesH3Props ?? {}))} {...(typeof divDiv1H30H3Props === "function" ? divDiv1H30H3Props(item) : (divDiv1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                    </div>
                                </div>
                            ),
                            journeySectionJourneyFivesItemWrapper,
                            journeySectionJourneyFivesRenderer
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeFiveJourneySectionGenerated;
